import request from '@/utils/request'

/**
 * 查询小区商铺列表
 * @param {Object} params 查询参数
 * @returns {Promise} 返回Promise对象
 */
export function queryShopCommunity(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shop.queryShopCommunity',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 审核小区商铺
 * @param {Object} data 审核数据
 * @returns {Promise} 返回Promise对象
 */
export function auditShopCommunity(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shop.auditShopCommunity',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}